// chatContext.js — mapeia o CONTEXTO escolhido no composer do Chat (nenhum /
// pasta local / repo do GitHub) para os campos de input de `createCodeSession`.
//
// O Chat home deixa o usuário anexar um contexto via `@` ou pela pill "Contexto":
//   - null                              → conversa pura (sem diretório)
//   - { kind: 'folder', path }          → pasta local vira o directory da sessão
//   - { kind: 'github', repo }          → createCodeSession resolve/clona o repo
//                                          num checkout local (window.apolo.repo.resolveRemote)
//
// Puro — sem I/O, unit-testável. Espelha os campos que createCodeSession já
// entende (input.directory / input.github_repo).

/**
 * @param {null | { kind: 'folder', path?: string } | { kind: 'github', repo?: object }} context
 * @returns {{ directory?: string, github_repo?: object }}
 */
export function contextToSessionInput(context) {
  if (!context) return {};
  if (context.kind === 'folder' && typeof context.path === 'string' && context.path.startsWith('/')) {
    return { directory: context.path };
  }
  if (context.kind === 'github' && context.repo?.full_name) {
    return { github_repo: context.repo };
  }
  return {};
}

/** Rótulo curto pra pill de contexto (repo → nome, pasta → basename, senão null). */
export function contextLabel(context) {
  if (context?.kind === 'github') return context.repo?.name || context.repo?.full_name || null;
  if (context?.kind === 'folder' && typeof context.path === 'string') {
    return context.path.split('/').filter(Boolean).pop() || context.path;
  }
  return null;
}
